import * as requests from "../coraWebComponents/utils/requests";
import CoraError from '../coraWebComponents/utils/coraError';
import Urls from "../constants/Urls";

export const signIn = async (username, password) => {
  try {
    return await requests.signIn(username, password);
  }
  catch (error) {
    throw error;
  }
}

export const updatePassword = async (password) => {
  const url = '/api/changePassword';
  const data = {
    password
  };

  try {
    let res = await requests.post(url, data);
    return res;
  }
  catch (error) {
    throw error;
  }
}

export const getCurrentUser = async () => {
  const url = '/api/sprava/SpUz/current';
  try {
    let res = await requests.get(url);
    return res;
  }
  catch (error) {
    throw error;
  }
}
export const refreshToken = () => requests.refreshToken();

export const verifyCode = async (code) => {
  try {
    return await requests.verifyCode(code);
  }
  catch (error) {
    throw error;
  }
}

export const createCode = async (username) => {
  try {
    return await requests.createCode(username);
  }
  catch (error) {
    throw error;
  }
}



export const updateUser = async (data) => {
  try {
    let res = await requests.post(Urls.UpdateUser, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const formatUzivatel = (uzivatel) => {
  return uzivatel.Osoba ? {
    meno: uzivatel.Osoba.OsobneUdaje.MENO || "",
    priezvisko: uzivatel.Osoba.OsobneUdaje.PRIEZVISKO || "",
    nazov: uzivatel.Osoba.OsobneUdaje.NAZOV || "",
    ico: uzivatel.Osoba.OsobneUdaje.ICO || "",
    ulica: uzivatel.Osoba.Adresa.ULICA || "",
    cs: uzivatel.Osoba.Adresa.CS ? uzivatel.Osoba.Adresa.CS : null,
    co: uzivatel.Osoba.Adresa.CO || "",
    psc: uzivatel.Osoba.Adresa.PSC || undefined,
    obec: uzivatel.Osoba.Adresa.OBEC || "",
    email: uzivatel.Osoba.Kontakt.EMAIL || "",
    telefon: uzivatel.Osoba.Kontakt.TELEFON || "",
    radioValue: uzivatel.Osoba.OsobneUdaje.I_O_TYP === 1
      ? { label: "Fyzická osoba", value: "fyzOsoba" }
      : { label: "Právnická osoba", value: "pravOsoba" },
  } : {
    meno: uzivatel.MENO || uzivatel.meno || "",
    priezvisko: uzivatel.PRIEZVISKO || uzivatel.priezvisko || "",
    nazov: uzivatel.NAZOV_PO || uzivatel.nazov || "",
    ico: uzivatel.ICO || uzivatel.ico || "",
    ulica: uzivatel.ULICA || uzivatel.ulica || "",
    cs: uzivatel.CS ? Number(uzivatel.CS) : (uzivatel.cs ? Number(uzivatel.cs) : null),
    co: uzivatel.CO || uzivatel.co || "",
    psc: uzivatel.PSC || uzivatel.psc || undefined,
    obec: uzivatel.OBEC || uzivatel.obec || "",
    email: uzivatel.EMAIL || uzivatel.email || "",
    telefon: uzivatel.MOBIL || uzivatel.telefon || "",
    radioValue: uzivatel.radioValue || (
      uzivatel.IS_FO
        ? { label: "Fyzická osoba", value: "fyzOsoba" }
        : { label: "Právnická osoba", value: "pravOsoba" }
    )
  }
}

export const getMeno = (uzivatel) => {
  if (!uzivatel) return null;
  if (!uzivatel.Osoba || !uzivatel.Osoba.OsobneUdaje) return uzivatel.N_UZ;
  if (uzivatel.Osoba.OsobneUdaje.I_O_TYP === 2 && uzivatel.Osoba.OsobneUdaje.NAZOV)
    return uzivatel.Osoba.OsobneUdaje.NAZOV;
  if (uzivatel.Osoba.OsobneUdaje.I_O_TYP === 1 && uzivatel.Osoba.OsobneUdaje.PRIEZVISKO && uzivatel.Osoba.OsobneUdaje.MENO)
    return uzivatel.Osoba.OsobneUdaje.PRIEZVISKO + " " + uzivatel.Osoba.OsobneUdaje.MENO;
  return uzivatel.N_UZ;
}
